(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
/*------------------------------------*\
    TYPEMATE

    Run text filters across DOM elements
    to help achieve nice typesetting
    on dynamic content.
\*------------------------------------*/
class TypeMate {
  constructor(parent, settings = {}) {
    let self = this;

    // Set some settings, by merging defaults and passed settings
    self.settings = _extends({
      minWords: 4,
      selector: 'p',
      ignoreClass: 'js-typemate__ignore'
    }, settings);

    // Either load from root or the passed parent element
    if (typeof parent === 'undefined') {
      self.elems = [...document.querySelectorAll(self.settings.selector)];
    } else {
      self.elems = [...parent.querySelectorAll(self.settings.selector)];
    }
  }

  /**
   * Apply formatting to the loaded elements
   * @return void
   */
  apply() {
    let self = this;
    self.elems.map(elem => {
      // Bail out if the ignore class is present on this element
      if (elem.classList.contains(self.settings.ignoreClass)) {
        return false;
      }

      // The result string will be tacked on to this
      var result = '';

      // Split words/tags into array
      let textItems = elem.innerHTML.trim().replace(/&nbsp;/g, '').split(/ (?=[^>]*(?:<|$))/);

      // Check if the text warrants this module
      if (textItems.length < self.settings.minWords) {
        return;
      }

      // Run orphans filter
      textItems = self.preventOrphans(textItems);

      // Join the words back together
      result = textItems.join(' ');

      // Replace whitespace after no break spaces
      result = result.replace(/&nbsp; /g, '&nbsp;');

      // Set the content of the element with our shiny string
      elem.innerHTML = result;
    });
  }

  /**
   * Apply the orphans filter to the passed text and return it
   * @param {string} textItems
   */
  preventOrphans(textItems) {
    // Find the second to last work
    var targetWord = textItems[textItems.length - 2];

    // Stick a no break space to the end of the word and replace the instance in the array
    textItems[textItems.length - 2] = targetWord + '&nbsp;';
    return textItems;
  }

  /**
   * Reset any formatting
   * @return void
   */
  reset() {
    let self = this;
    self.elems.map(elem => {
      elem.innerHTML = elem.innerHTML.replace(/&nbsp;/g, ' ');
    });
  }
  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }
}
module.exports = function (parent, settings = {}) {
  return new TypeMate(parent, settings);
};
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(TypeMate, "TypeMate", "/var/www/html/websites/livecbm-com/src/frontend/components/typemate.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();